module.exports = __webpack_public_path__ + "static/media/background.b536ec88.jpg";